import { ref } from 'vue'

// Gedeelde singleton-state - werkt cross-component zonder Pinia
const isOpen      = ref(false)
const lastAdded   = ref(null)  // { product, quantity }

export function useCartModal() {
  const open = (product, quantity = 1) => {
    lastAdded.value = { product, quantity }
    isOpen.value    = true
  }
  const close = () => { isOpen.value = false }

  return { isOpen, lastAdded, open, close }
}
